import * as d3 from 'd3';
import {impactSectionList} from '../data/impactSectionList.js';
import {tenprinciplesSectionList} from '../data/tenprinciplesSectionList.js';
import {SDGSectionList} from '../data/SDGSectionList.js';
const data = require('../data/data.json');



function getData() {
  return data;
}
function getImpactSectionQuestionList(){
  return impactSectionList;
}
function getTenprinciplesSectionQuestionList(){
  return tenprinciplesSectionList;
}
function getSDGSectionQuestionList(){
  return SDGSectionList;
}


export {
  getData,
  getImpactSectionQuestionList,
  getTenprinciplesSectionQuestionList,
  getSDGSectionQuestionList
}



// WEBPACK FOOTER //
// ./src/App/utils/api.js